/* eslint-disable no-underscore-dangle */
import { APP_DOMAIN } from 'appenv';
import { gql } from '@apollo/client';
import { fetchAllPage } from 'network/common/cmsUtils';
import { CommonLocalizableString } from 'network/common/cmsFragment';

const fetchBoothTaxonomiesQuery = gql`
  query fetchBoothTaxonomiesQuery(
    $domain: String!,
    $count: Int,
    $cursor: String,
    $locales: [Locale!]!
  ) {
    data: eventByDomain(domain: $domain) {
      id
      boothTaxonomies(first: $count, after: $cursor) {
        pageInfo {
          hasNextPage
          endCursor
        }
        nodes {
          id
          name {
            ...CommonLocalizableString
          }
          parentSupercategory {
            id
          }
        }
      }
    }
  }

  ${CommonLocalizableString}
`;

export interface FetchBoothTaxonomiesProps {
  domain?: string;
  count?: number;
  cursor?: string;
  locales?: string[];
}

const fetchBoothTaxonomies = async (config: FetchBoothTaxonomiesProps = {}) => {
  const pages = await fetchAllPage(
    (data: any) => data.data.boothTaxonomies.pageInfo,
    fetchBoothTaxonomiesQuery,
    {
      count: 20,
      domain: APP_DOMAIN,
      ...config,
    },
  );

  const boothTaxonomies = pages
    .flatMap((page) => page.data.boothTaxonomies.nodes);

  const result = {
    id: pages[0].data.id,
    boothTaxonomies,
  };

  return result;
};

export default fetchBoothTaxonomies;
